<template>
    <div class="link">
        <div class="from-to-container">
            <div class="from">
                <div class="image"></div>
            </div>
            <div class="arrow">
                <i class="fas fa-long-arrow-alt-right"></i>
            </div>
            <div class="to">
                <div class="loading"><i class="fas fa-question"></i></div>
                <div class="image"></div>
            </div>
        </div>

        <div class="space-20"></div>

        <div class="dialog">
            <i class="fas fa-info-circle"></i>
            <div>
                Please enter your {{site_name}} forums email to link your Minecraft account.
                Linking your account allows you, and others,
                to view your friendships and marriage status on your profile page. You can unlink
                your account at any time using <i>/friends unlink</i> in-game.
            </div>
        </div>

        <div class="forums-email">
            <div class="space-20"></div>
            <label class="label">
                <input
                        v-bind:placeholder="'Please enter your ' + [[site_name]] + ' forums email'"
                        id="email"
                        type="email"
                />
            </label>
            <div class="space-20"></div>
            <div class="link-btn" style="display:none;">
                Link
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // Change the first character to uppercase
                site_name: this.$site_name.charAt(0).toUpperCase() + this.$site_name.slice(1)
            }
        }
    }
</script>